

import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Container, Stack } from "@mui/material";
import home_page_Image from "../../../../Assets/home_page_Image.png";
// import home_side_image from "../../Assets/Overlay.png"; // Ensure this is the correct path
import { useNavigate } from "react-router-dom";
import { adminUrl } from "../../../../constants";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../ReduxStore/actions";
import ModalApproveButton from "../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";

// import actions from "../../../ReduxStore/actions/index";
// import { useDispatch } from "react-redux";
// import { adminUrl } from "../../../constants";

const LandingPage = ({ bannerDates, values, showSubmitButton,onClose,sectionNameForApproveAndReject}) => {
    const navigate = useNavigate()

    const handleGoLoginpage = () => {
        navigate("/login")
    }

    const handleGoStakeNowPage = () => {
        navigate("/stake-now")
    }


    const [responseData, setResponseData] = useState()

    console.log(values, "valuesssss")
    console.log(responseData, "responseDatattaatatatt")
    const TableId = useSelector((state) => state.Table.TableId);
   

    const dispatch = useDispatch()

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId && !values) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getHomeSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETHOMESECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "Home section retrieved successfully.") {
                    console.log("hiiii")

                    setResponseData(response?.payload?.data)
                    // setUploadedFile({
                    //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
                    //     type: "img",
                    //     progress: 100,
                    // }
                    // )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, []);


    return (
        <Box>
            <Box
                sx={{
                    // position: "relative", // Needed for positioning child elements
                    background: `linear-gradient(90deg, #000000 0%, #54545400 100%), url(${adminUrl}${responseData?.additional_data[0]?.banner || values?.image})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    overflow: "hidden",
                    padding: "80px 0px",
                    // left:"100px"
                    // minHeight: "90vh", // Adjust height as needed
                }}
            >
                <Container maxWidth="lg" sx={{ zIndex: 2 }}>
                    <Box
                        display="flex"
                        // alignItems="center"
                        justifyContent="start"
                        flexWrap="wrap"
                    >
                        {/* Left Section */}
                        <Box
                            sx={{

                                color: "#fff",
                            }}
                        >
                            <Typography
                                variant="h1"
                                textAlign="start"
                            // sx={{
                            //     fontWeight: "bold",
                            //     fontSize: "50px",
                            //     // mb:"1px"
                            // }}
                            >
                                {responseData?.heading || values?.title || "Default Heading"}

                            </Typography>
                            <Typography
                                variant="h2"
                                textAlign="start"
                                sx={{

                                    mb: 2,
                                }}
                            >
                                {responseData?.sub_heading || values?.subtitle || "Default Subtitle"}

                            </Typography>
                            <Typography
                                variant="body1"
                                textAlign="start"
                                sx={{
                                    mb: 5,
                                    lineHeight: "1.6",
                                    color: "#ffffff",

                                    maxWidth: "500px",


                                    letterSpacing: "0px",

                                    opacity: 1
                                }}
                            >
                                {responseData?.content || values?.content || "Default Content"}
                                {/* Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took */}
                            </Typography>
                            <Stack spacing={2} direction="row">
                                <Button
                                    variant="contained"
                                    onClick={handleGoStakeNowPage}

                                    sx={{
                                        // backgroundColor: "#C38F51",
                                        textTransform: "none",
                                        color: "white",
                                        fontSize: "16px",
                                        // padding: "0px 40px",
                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                        minHeight: "40px",
                                        borderRadius: "23px",
                                        background: "#C38F51 0% 0% no-repeat padding-box",
                                        // "&:hover": {
                                        //     backgroundColor: "#3B4056",
                                        // },
                                    }}
                                >
                                    {responseData?.additional_data?.[0]?.primary_button_text || values?.primary_button_text || "Secondary Button Text"}

                                </Button>
                                <Button
                                    variant="outlined"
                                    onClick={handleGoLoginpage}
                                    sx={{
                                        // backgroundColor: "#FFAA17",
                                        border: "1px solid #C38F51",
                                        textTransform: "none",
                                        color: "white",
                                        fontSize: "16px",
                                        padding: { xs: "0px 20px", md: "0px 40px" },
                                        minHeight: "40px",
                                        borderRadius: "23px",
                                        // font: "normal normal normal 16px / 25px Roboto",
                                        letterSpacing: "0px",
                                        color: "#C38F51",
                                        background: "white"
                                        // "&:hover": {
                                        //     backgroundColor: "#C38F51",
                                        // },
                                    }}
                                >
                                    {responseData?.additional_data?.[0]?.secondary_button_text || values?.secondary_button_text || "Secondary Button Text"}

                                </Button>
                            </Stack>
                        </Box>
                    </Box>
                </Container >
            </Box >
            <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject}/>
        </Box>
    );
};

export default LandingPage;
